module.exports = __webpack_public_path__ + "img/autorizationUA.63ca8b47.png";